import type { AxiosInstance } from 'axios'

// Get version from app.json
import appJson from '../../../../../app.json'

export const setVersionInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use((config) => {
    config.headers['X-Frontend-Version'] = appJson.expo.version
    return config
  })
}
